import iconOk from '@frontend/jetlend-assets/icons/icon--ok.svg';
import iconOkV2 from '@frontend/jetlend-assets/icons/icon--ok-v2.svg';
import iconOkV3 from '@frontend/jetlend-assets/icons/icon--ok-v3.svg';
import iconError from '@frontend/jetlend-assets/icons/icon--stop.svg';
import iconBanCircle from '@frontend/jetlend-assets/icons/icon--ban-circle.svg';
import React from 'react';
import {
    IconsType,
    IProps,
} from './ProgressCaption';
import Loader from '../loaders/Loader';
import { buildClassNames } from '@ui/utils/classNameUtils';
import styles from './ProgressCaption.module.scss';

/**
 * Собирает конфиг с иконками в зависимости от выбранного типа иконок и других параметров
 */
export function getIcons(iconType: IconsType, params?: Pick<IProps, 'bordered'>) {
    switch (iconType) {
    case 1:
        return {
            success: iconOk,
            error: iconError,
            loading: params.bordered
                ? <Loader size="normal" spinnerType="three-sides-circle" grey />
                : <Loader size="large" />,
        };
    case 2:
        return {
            success: iconOkV2,
            error: iconBanCircle,
            loading: (
                <div className={buildClassNames(styles, ['loader-wrapper', params.bordered && 'bordered'])}>
                    <Loader size="small" spinnerType="three-sides-circle" inverted />
                </div>
            ),
        };
    case 3:
        return {
            success: iconOkV3,
            error: iconError,
            loading: params.bordered
                ? <Loader size="normal" spinnerType="three-sides-circle" grey />
                : <Loader size="large" />,
        };
    default: {
        return {
            success: iconOk,
            error: iconError,
            loading: params.bordered
                ? <Loader size="normal" spinnerType="three-sides-circle" grey />
                : <Loader size="large" />,
        };
    }
    }
}